/**
 * @generated SignedSource<<6b81ef456b01e94e494ed7210164c0cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersApplicationBase$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsPostiesArticle" | "helpersCheckIsPostiesPage">;
  readonly " $fragmentType": "helpersApplicationBase";
};
export type helpersApplicationBase$key = {
  readonly " $data"?: helpersApplicationBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersApplicationBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersApplicationBase"
};

(node as any).hash = "d4b2413661c6b8a621250453a447dc1d";

export default node;
